import $ from 'jquery';

const _namespace = 'toggle';

export const toggle = {

  /**
   * Toggle content
   *
   * @param {Object} options - Options to be used
   * @param {jquery} options.$element - jquery collection
   */
  bind(trigger, target, callback) {
    $(trigger).on(`click.${_namespace}`, event => {
      event.preventDefault();
      this.action(target);

      if (typeof callback === 'function') {
        callback(event, target);
      }
    });
  },

  /**
   * Unbind a toggle listener
   *
   * @param {Object} options - Options to be used
   * @param {jquery} options.$element - jquery collection
   */
  unbind(trigger) {
    trigger.off(`click.${_namespace}`);
  },

  /**
   * Trigger a toggle action
   *
   * @param {Object} event
   */
  action(element) {
    $(element).toggleClass('is-active');
  },
};

/**
 * Sequential resolution of promises
 * @param {*} fns
 */
export async function runInSequence(fns) {
  const results = [];
  let response;

  for (const fn of fns) {
    try {
      response = await fn();
    } catch (error) {
      response = error;
    }

    results.push(response);
  }

  return results;
}
